module.exports = __webpack_public_path__ + "static/media/ic_file.a3eb7e2f.svg";